module.exports = __webpack_public_path__ + "img/header-weddingRingsSignature@2x.cd3e8c4.jpg";